if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');
      this.headerOffset = this.calculateHeaderOffset();

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });

      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }

      document.addEventListener('DOMContentLoaded', this.setTransparentClass.bind(this));

      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
          window.dispatchEvent(new Event('scroll'));
        } else {
          this.classList.add('is-sticky');
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class with debounced scroll event
      window.addEventListener('scroll', debounce(this.setStickyClass.bind(this), 10), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });
      
      window.addEventListener('resize', debounce(() => {
        this.headerOffset = this.calculateHeaderOffset();
      }, 100), { passive: true });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {
        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');
        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    calculateHeaderOffset() {
      return this.getBoundingClientRect().top + window.scrollY;
    }

    setStickyClass() {
      // Get the current scroll position
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
    
      // Ensure offset is correctly calculated and consistent across all browsers
      const shouldBeSticky = scrollTop > this.headerOffset;
    
      if (shouldBeSticky && !this.classList.contains('is-sticky')) {
        // Add 'is-sticky' class when scrolled past the headerOffset
        this.classList.add('is-sticky');
        document.querySelector('.product-information')?.classList.add('is-sticky');
      } else if (!shouldBeSticky && scrollTop === 0 && this.classList.contains('is-sticky')) {
        // Only remove the 'is-sticky' class when scrolling back to the top
        this.classList.remove('is-sticky');
        document.querySelector('.product-information')?.classList.remove('is-sticky');
      }
    }
    
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }

    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }

    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }

    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
        const elapsedTime = time - animationStart;
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };
      window.requestAnimationFrame(handleAnimation);
    }

    setTransparentClass() {
      this.template_header = document.querySelector('.template-header');
      if (this.template_header && this.template_header.classList.contains('template-header--has-image-true') && this.template_header.dataset.sectionIndex == 1) {
        this.classList.remove('transparent--false');
        this.classList.add('transparent--true');
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

// /**
//  *  @class
//  *  @function FullMenu
//  */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.buttonsAll = this.querySelectorAll('.full-menu--link-parent');
      this.subButtons = this.querySelectorAll('.full-menu--link-child');

      this.header = this.closest('.header');

      this.panel  = this.querySelector('.full-menu--panel');
      this.panel1 = this.querySelector('.full-menu--panel--level-1');
      this.panel2 = this.querySelector('.full-menu--panel--level-2');

      this.cc     = this.querySelector('.full-menu--cc');
      this.toggle = this.querySelector('.full-menu--toggle');

      this.panelWidth = 320;
      this.level2Extra = 88;
      this.level3Extra = 330;
    }

    connectedCallback() {
      this.buttonsAll.forEach((button) => {
        button.addEventListener('mouseenter', (e) => this.onParentHover(button, e));
        button.addEventListener('focus',     (e) => this.onParentHover(button, e));
        button.addEventListener('keydown',   (e) => this.onParentKeydown(button, e));
      });

      this.subButtons.forEach((button) => {
        button.addEventListener('mouseenter', (e) => this.onChildHover(button, e));
      });

      this.panel2?.addEventListener('mouseleave', (e) => this.onPanelLeave(e));

      this.toggle?.addEventListener('click', () => this.onToggleClick());

      this.cc?.addEventListener('mousemove', () => this.onCC());
      this.addEventListener('mouseleave', () => this.onCC());

      document.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.onCC();
        }
      });
    }

    /* ---------------- Helpers ---------------- */

    setPanelWidth(value) {
      this.panel?.style.setProperty('--menu-panel-width', value + 'px');
    }

    clearSubmenus() {
      this.panel1?.querySelectorAll('.full-menu--subpanel')
        .forEach(p => p.classList.remove('active'));

      this.panel2?.querySelectorAll('.full-menu--subpanel')
        .forEach(p => p.classList.remove('active'));

      this.clearActiveByDefault();
    }

    clearActiveByDefault(scope = this.panel1) {
      scope?.querySelectorAll('.full-menu--link-child.active-by-default')
        .forEach(el => el.classList.remove('active-by-default'));
    }

    setActiveByDefault(button) {
      if (!button) return;
      this.clearActiveByDefault(button.closest('.full-menu--panel--level-1'));
      button.classList.add('active-by-default');
    }

    openHeader(button) {
      if (!this.header) return;

      this.header.classList.add('open-menu');
      document.body.classList.add('lock-all', 'open-principal-menu');

      if (button?.textContent.trim() === 'About') {
        this.header.classList.add('show-menu-secondary');
      } else {
        this.header.classList.remove('show-menu-secondary');
      }
    }

    closeHeader() {
      if (!this.header) return;

      this.header.classList.remove('open-menu', 'show-menu-secondary');
      document.body.classList.remove('lock-all', 'open-principal-menu');
    }

    /* ---------------- Events ---------------- */

    onParentKeydown(button, e) {
      if (e.code.toUpperCase() !== 'ENTER') return;
      if (!button.classList.contains('has-sub-menu')) return;

      this.onParentHover(button, e);
    }

    onParentHover(button, e) {
      if (!this.panel) return;

      if (!button.classList.contains('has-sub-menu')) {
        this.onCC();
        return;
      }

      this.openHeader(button);
      this.clearSubmenus();

      // ✅ nivel 2 visible
      this.setPanelWidth(this.panelWidth + this.level2Extra);

      const targetSelector = button.dataset.target;
      if (!targetSelector || !this.panel1) return;

      const target = this.panel1.querySelector(targetSelector);
      if (target) {
        target.classList.add('active');
        this.panel1.scrollTop = 0;
      }

      window.dispatchEvent(new Event('resize'));
      e?.preventDefault();
    }

    onChildHover(button, e) {
      if (!this.panel || !this.panel2) return;
      if (!button.classList.contains('has-sub-menu')) return;

      const targetSelector = button.dataset.target;
      if (!targetSelector) return;

      // ✅ nivel 3 visible
      this.setPanelWidth(this.panelWidth + this.level3Extra);

      this.panel2.querySelectorAll('.full-menu--subpanel')
        .forEach(p => p.classList.remove('active'));

      const target = this.panel2.querySelector(targetSelector);
      if (target) {
        target.classList.add('active');
        this.panel2.scrollTop = 0;
      }

      this.setActiveByDefault(button);
      e?.preventDefault();
    }

    onPanelLeave(e) {
      if (this.panel1?.contains(e.relatedTarget)) return;

      // ⬅️ volver a nivel 2
      this.setPanelWidth(this.panelWidth + this.level2Extra);

      this.panel2?.querySelectorAll('.full-menu--subpanel')
        .forEach(p => p.classList.remove('active'));
    }

    onToggleClick() {
      this.openHeader();
      this.setPanelWidth(this.panelWidth * 2);
    }

    onCC() {
      if (!this.panel) return;

      this.setPanelWidth(this.panelWidth);
      this.clearSubmenus();
      this.closeHeader();
    }
  }

  customElements.define('full-menu', FullMenu);
}



